import defineComponent from 'flight';

function FilterButtonsUI() {
    this.defaultAttrs({
        filterButtonsSelector: '[data-search-result-toggle-filter]',
        filterCategoriesButtonsSelector:
            '[data-search-result-toggle-filter-categories]',
        filterSubdepartmentButtonsSelector:
            '[data-search-result-toggle-filter-subdepartment]',
        filterFilterButtonsSelector:
            '[data-search-result-toggle-filter-filter]',
        filterSortButtonsSelector: '[data-search-result-toggle-filter-sort]'
    });

    this._filterButtonClicked = function(evt, el) {
        let buttons = this.select('filterButtonsSelector'),
            i,
            btn,
            context;

        for (i = 0; i < buttons.length; i++) {
            if (el.el !== buttons[i] && $(buttons[i]).hasClass('active')) {
                btn = $(buttons[i]);
                context = btn.data('toggle');

                this.trigger(document, 'ui:toggle:' + context, {
                    expand: !btn.hasClass('active')
                });
            }
        }
    };

    this._filterCategoriesButtonClicked = function(evt) {
        this.trigger(document, 'ui:search-result:on-open-filter-click', {
            modalHeader: 'Kategorier',
            name: 'categories',
            target: evt.currentTarget,
            menuSelector: '[data-expandable="search-filters-categories"]:eq(0)',
            targetSelector: this.attr.filterCategoriesButtonsSelector
        });
    };

    this._filterSubdepartmentButtonClicked = function(evt) {
        this.trigger(document, 'ui:search-result:on-open-filter-click', {
            modalHeader: 'Avdelningar',
            name: 'subdepartment',
            target: evt.currentTarget,
            menuSelector: '.tag-navigation-filter-subdepartments:eq(0)',
            targetSelector: this.attr.filterSubdepartmentButtonsSelector
        });
    };

    this._filterFilterButtonClicked = function(evt) {
        this.trigger(document, 'ui:search-result:on-open-filter-click', {
            modalHeader: 'Filter',
            name: 'filters',
            target: evt.currentTarget,
            menuSelector: '.search-filters-section-filters:eq(0)',
            targetSelector: this.attr.filterFilterButtonsSelector
        });
    };

    this._filterSortButtonClicked = function(evt) {
        this.trigger(document, 'ui:search-result:on-open-filter-click', {
            modalHeader: 'Sortera',
            name: 'sort',
            target: evt.currentTarget,
            menuSelector: '[data-expandable="search-filters-sort"]:eq(0)',
            targetSelector: this.attr.filterSortButtonsSelector
        });
    };

    this.after('initialize', function() {
        this.on('click', {
            filterButtonsSelector: this._filterButtonClicked,
            filterCategoriesButtonsSelector: this
                ._filterCategoriesButtonClicked,
            filterSubdepartmentButtonsSelector: this
                ._filterSubdepartmentButtonClicked,
            filterFilterButtonsSelector: this._filterFilterButtonClicked,
            filterSortButtonsSelector: this._filterSortButtonClicked
        });
    });
}

export default defineComponent.component(FilterButtonsUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/filter-buttons-ui.js